VP = window.VP || {};

(function( $ ) {
	VP.search = {
		wrapper: $('.vp-header'),
		window: $(window),
		desktopSize: 1200,
		isOpen: false,

		init: function () {
			var _this = this;
			_this.eventHandlers();
			_this.searchFilter();
			_this.initMediaCenterStyles();
		},

		eventHandlers: function() {
			var _this = this;

			$('.vp-nav__search', _this.wrapper).click(function(e) {
				e.preventDefault();
				if( _this.wrapper.hasClass('vp-header--searching') ) {
					_this.close();
				} else {
					_this.open();
				}

			});

			_this.window.on("resize",function(e) {
				VP.search.updateNavSearchLabel();
			});

			// on search fill
			$(document.body).on('keyup', '.gsc-input' ,function(e){
				VP.search.updateNavSearchLabel();
			});

			$('.vp-search__close', _this.wrapper).on('click', function(e) {
				e.preventDefault();
					_this.close();
				});
		},

		initMediaCenterStyles: function() {
			var containMediaCenter = window.location.href.match(/\?c=media-center/gi);
			if (containMediaCenter) {
				$('body').addClass('vp-media-center-search');
			}
		},

		open: function() {
			var _this = this;
			VP.nav.close();
			$('.gsc-input', _this.wrapper).attr('placeholder', 'Search website').focus();
			VP.search.updateNavSearchLabel();
			_this.wrapper.addClass('vp-header--searching');
			_this.isOpen = true;
		},

		close: function() {
			var _this = this;
			_this.wrapper.removeClass('vp-header--searching');
			_this.isOpen = false;
		},

		updateNavSearchLabel: function() {
			var navLabel = $('.js-nav-search-label'),
				labelStr = '';

			if( typeof google !== 'undefined' && typeof google.search.cse.element !== 'undefined' && google.search.cse.element.getElement('search-box-nav') !== null  && google.search.cse.element.getElement('search-box-nav').getInputQuery() ) {
				if(VP.search.window.width() < VP.search.desktopSize) {
					labelStr = navLabel.data('smallFill');
				} else {
					labelStr = navLabel.data('largeFill');
				}
			} else {
				if(VP.search.window.width() < VP.search.desktopSize) {
					labelStr = navLabel.data('smallEmpty');
				} else {
					labelStr = navLabel.data('largeEmpty');
				}
			}

			$('.js-nav-search-label').text( labelStr );
		},

		searchFilter: function() {
			/* This will rearrange the search filters on load. will poll until the search results load */
			if( $('.vp-search-header').length ) {
				var int = setInterval( function() {
					if (typeof google !== 'undefined' && google.search.cse) {
						if( google.search.cse.element.getElement('search') && $(document).find(".gsc-tabsArea .gsc-tabHeader").length ) {

							$(".gsc-tabsArea .gsc-tabHeader").each(function() {
								label = $('span', $(this)).text();
								if( label === 'Uwishunu.com' || label === 'uwishunu' ) {
									$(this).addClass('tab-uwishunu');
								}
								if( label === 'Visitphilly.com' || label === 'visitphilly') {
									$(this).addClass('tab-visitphilly');
								}
								if( label === 'Visit Philly Media Center' || label === 'media center' ) {
									$(this).addClass('tab-media-center');
								}
							});
								clearInterval(int);

							}
					}
				}, 200);
			}
		}

	};
})(jQuery);
